export default "__VITE_ASSET__DqrH23Fs__"